import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';

const PermissionDenied = ({ message = "You don't have permission to access this resource" }) => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      textAlign="center"
    >
      <LockIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
      <Typography variant="h5"
gutterBottom>
        Access Denied
      </Typography>
      <Typography variant="body1"
color="text.secondary"
sx={{ mb: 3 }}>
        {message}
      </Typography>
      <Button 
        variant="contained" 
        onClick={() => navigate('/dashboard')}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default PermissionDenied;